const CompanyStatus = {
    FullyRegistered : 0,
    PendingConfirmation : 1,
    ConfirmationSent : 2,
   
};

export default CompanyStatus;
